/**
 * Se a pessoa pode alguma coisa -- a pergunta que menu, rota e botao fazem.
 *
 * O nucleo e puro de proposito: quem le o localStorage e `userCodes`, e
 * so ela. Assim a regra, que e a parte que erra, da para testar sem navegador.
 *
 * O codigo tem a forma `<ferramenta>:<acao>` -- `accounts.grupos:editar`. Vem
 * pronto do `GET /api/user/{id}/permission`, na chave `codes`, montado pelo
 * PermService a partir de `feature.code` e do nome da acao.
 */

// Chave de localStorage gravada por services/api/permissionManagement.js -- o mesmo nome do resto da plataforma.
const STORAGE_KEY = 'permissionsApi';

/**
 * A REGRA DE FALHA, e ela e deliberada: na duvida, LIBERA.
 *
 * `codes` desconhecido -- nao carregou, deu erro, versao antiga da API sem a
 * chave `codes` -- devolve `true`. Tres razoes:
 *
 *  1. A API confere de verdade. `AuthService::isAuthorized()` monta o caminho
 *     a partir do host e da rota e confere contra a lista do usuario; quem nao
 *     pode toma 403 no endpoint. A tela e conveniencia, nao barreira.
 *  2. Falhar fechado aqui ja trancou a aplicacao uma vez: catalogo vazio ->
 *     arvore vazia -> ninguem e admin -> 403 em tudo -> laco de volta ao admin.
 *  3. Uma tela a mais visivel e incomodo. O app inteiro inacessivel e
 *     incidente.
 *
 * Lista vazia e diferente de desconhecida: `[]` quer dizer "carregou e a pessoa
 * nao tem nada", e ai fecha.
 */
export function can(code, codes, registered = null) {
    if (!code) {
        return true;
    }

    if (!Array.isArray(codes)) {
        return true;
    }

    if (codes.includes('*')) {
        return true;
    }

    // Permissao que AINDA NAO FOI CADASTRADA nao barra ninguem.
    //
    // `registered` e o catalogo do ambiente, nao a lista da pessoa. Sem essa
    // distincao, cadastrar a primeira permissao trancaria todas as telas de
    // uma vez: as rotas daqui ja declaram catorze codigos, e no instante em que
    // `codes` comeca a ser enviada os treze ainda nao cadastrados viram
    // negativa -- nao porque a pessoa nao pode, mas porque o codigo nao existe.
    //
    // Com o catalogo, cada permissao passa a valer quando e cadastrada. O
    // caminho deixa de ser um big-bang.
    if (Array.isArray(registered) && !registered.includes(code)) {
        return true;
    }

    return codes.includes(code);
}

/** Verdadeiro se puder qualquer um da lista. Para no com varios filhos. */
export function canAny(required, codes, registered = null) {
    if (!Array.isArray(required) || required.length === 0) {
        return true;
    }

    return required.some((code) => can(code, codes, registered));
}

/**
 * Os codigos do usuario, ou `null` quando nao se sabe.
 *
 * `null` e o valor que faz o `can` liberar. Devolver `[]` aqui num erro de
 * leitura trancaria a aplicacao inteira -- por isso a distincao e explicita e
 * o catch devolve null, nao array vazio.
 */
export function userCodes() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }

        const data = JSON.parse(raw);
        return Array.isArray(data?.codes) ? data.codes : null;
    } catch {
        return null;
    }
}

/**
 * Os codigos que EXISTEM no ambiente, ou `null` quando nao se sabe.
 *
 * Catalogo, nao permissao: diz o que ja foi cadastrado, para que uma permissao
 * ainda inexistente nao barre ninguem. `null` faz o `can` conferir so contra
 * a lista da pessoa, que e o comportamento de antes.
 *
 * `codes_registrados` e o nome do campo na resposta do liberty/auth -- contrato externo, nao muda aqui.
 */
export function registeredCodes() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }

        const data = JSON.parse(raw);
        return Array.isArray(data?.codes_registrados) ? data.codes_registrados : null;
    } catch {
        return null;
    }
}

/** Atalho para as telas: `canNow('accounts.grupos:editar')`. */
export function canNow(code) {
    return can(code, userCodes(), registeredCodes());
}
